/**
 * Read-only view for legacy session notes.
 * @version 1
 */
import type { NoteDetail } from "@/core/types";

import { BehavioralData } from "../../components/BehavioralData";
import { PrescribeData } from "../../components/PrescribeData";
import { SessionMetaData } from "../../components/SessionMetaData";

type SessionNoteViewProps = {
  note: NoteDetail & {
    call_name?: string;
    intervention_reaction?: string;
    interventions?: string;
    patient_report?: string;
    patient_reported?: string;
    patient_task?: string;
    prescriber_interventions?: string;
    provider_type?: string;
  };
  patientName?: string;
};

export function SessionNoteView({ note, patientName }: SessionNoteViewProps) {
  return (
    <>
      <SessionMetaData note={note} patientName={patientName} />

      {note.provider_type?.startsWith("BEHAVIORAL") && <BehavioralData note={note} />}
      {note.provider_type === "PRESCRIBE" && <PrescribeData note={note} />}
    </>
  );
}
